import React from "react";
import { useEffect, useState } from "react";
import styles from "../styles/styles";
import { PARAMETER_MAP } from "../util/PARAMETER_MAP";
import { useGaugeState } from "@mui/x-charts";
import { Button, Box, Paper, Typography } from "@mui/material";
import { useAuth } from '../contexts/AuthContext';
import UserEmailDisplay from "../components/UserEmailDisplay/UserEmailDisplay";
import FailureMatrix from "./FailureMatrix";
import EmergencyMatrix from "./EmergencyMatrix";
import FireMatrix from "./FireMatrix";
import DerailmentMatrix from "./DerailmentMatrix";
import BrakeMatrix from "./BrakeMatrix";
import TractionMatrix from "./TractionMatrix";
import PantographMatrix from "./PantographMatrix";
import DoorsMatrix from "./DoorsMatrix";
import TrainHVACPanel from "./TrainHVACPanel";
import TrainStatusHeader from "./TrainStatusHeader";
import EmergencyStatusGrid from "./EmergencyStatusGrid";
import BypassStatusGrid from "./BypassStatusGrid";
import TrainModePanel from "./TrainModePanel";
import AlertStackPanel from "./AlertStackPanel";
import TrainMiniMap from "./TrainMiniMap";
import useTrainMonitor from "../app/hooks/useTrainMonitor";
import { monitorValue } from "../util/monitorUtils";
import DoorsSection from "./sections/DoorsSection";
import PantographSection from "./sections/PantographSection";
import FireSection from "./sections/FireSection";
import TractionSection from "./sections/TractionSection";
import BrakeSection from "./sections/BrakeSection";
import DerailmentSection from "./sections/DerailmentSection";
import EmergencySection from "./sections/EmergencySection";
import ComfortSection from "./sections/ComfortSection";
import useTrainDashboardMonitor from "../app/hooks/useTrainDashboardMonitor";
function Velocimetro() {
    const { valueAngle, outerRadius, cx, cy, value } = useGaugeState();

    if (valueAngle === null) return null;

    const target = {
        x: cx + outerRadius * Math.sin(valueAngle),
        y: cy - outerRadius * Math.cos(valueAngle),
    };

    return (
        <g>
            <circle cx={cx} cy={cy} r={5} fill="red" />
            <path
                d={`M ${cx} ${cy} L ${target.x} ${target.y}`}
                stroke="red"
                strokeWidth={3}
            />
            <text
                x={cx}
                y={cy + 30}
                textAnchor="middle"
                fill="#66fcf1"
                fontSize="20"
                fontWeight="600"
            >
                {value.toFixed(0)} km/h
            </text>
        </g>
    );
}

function TrainView(props) {
    const { userInfo } = useAuth();

    const {
        GlobalOverlays,

        trainSelected,
        trainInfo,
        trains,
        cars,

        setCarSelected,
        fetchCar,
        setTrainSelected,

        selectedParam,
        setSelectedParam,

        trainHistory,
        setTrainHistory,

        timeRange,
        setTimeRange,

        loadingChart,

        additionalCharts,
        chartTimeRanges,
        loadingGraficosAdicionais,

        updateChartParam,
        updateChartTimeRange,
        removeChart,
        addChart,

        MAX_ADDITIONAL_CHARTS,

        uniqueDisplayRows,

        lastUpdate,
        telemetryAlert,

        Gauge,
        GaugeContainer,
        GaugeReferenceArc,
        GaugeValueArc,

        MetricWidget,
        ParamAutocomplete,
        TimeRangeSelector,
        CarCard
    } = props;
    const {
        data: monitors,
        loading
    } = useTrainDashboardMonitor(
        trainSelected
    );

    const currentTrain = trains.find(
        t => t.id === trainSelected
    );

    const cabecalhoMonitor =
        monitors["cabecalho"] || {};

    const barraLateralMonitor =
        monitors["barra-lateral"] || {};

    const portasMonitor =
        monitors["portas"] || {};

    const pantografosMonitor =
        monitors["pantografos"] || {};

    const tracaoMonitor =
        monitors["tracao-e-alimentacao"] || {};

    const freioMonitor =
        monitors["freio"] || {};

    const descarrilamentoMonitor =
        monitors["descarrilamento"] || {};

    const incendioMonitor =
        monitors["incendio"] || {};

    const emergenciaMonitor =
        monitors["emergencia"] || {};

    const confortoMonitor =
        monitors["conforto"] || {};

    const gpsMonitor =
        monitors["gps"] || {};

    function getActiveGpsSource(monitor) {
        const sources = ["1", "8"];

        const candidates = sources.map(idx => {
            const latitude = monitorValue(monitor, `Latitude_${idx}`, 0);
            const longitude = monitorValue(monitor, `Longitude_${idx}`, 0);
            const timestamp = monitor[`Latitude_${idx}`]?.timestamp || 0;
            const hasFix = !(latitude === 0 && longitude === 0);

            return { idx, timestamp, hasFix };
        });

        const withFix = candidates.filter(c => c.hasFix);

        if (withFix.length > 0) {
            return withFix.reduce((a, b) =>
                b.timestamp > a.timestamp ? b : a
            ).idx;
        }

        return candidates.reduce((a, b) =>
            b.timestamp > a.timestamp ? b : a
        ).idx;
    }

    const activeGpsIdx = getActiveGpsSource(gpsMonitor);

    const gps = {
        latitude:
            monitorValue(
                gpsMonitor,
                `Latitude_${activeGpsIdx}`,
                0
            ),

        longitude:
            monitorValue(
                gpsMonitor,
                `Longitude_${activeGpsIdx}`,
                0
            ),

        altitude:
            monitorValue(
                gpsMonitor,
                `Altitude_${activeGpsIdx}`,
                0
            ),

        speed:
            monitorValue(
                barraLateralMonitor,
                "velocidade",
                0
            ),

        angle:
            monitorValue(
                gpsMonitor,
                `Angle_${activeGpsIdx}`,
                0
            ),

        accuracy:
            monitorValue(
                gpsMonitor,
                `Accuracy_${activeGpsIdx}`,
                0
            )
    };
    
    function parseLastUpdate(lastUpdateStr) {
        const [time, date] = lastUpdateStr.split(" • ");
        const [hours, minutes, seconds] = time.split(":").map(Number);
        const [day, month, year] = date.split("/").map(Number);

        return new Date(year, month - 1, day, hours, minutes, seconds);
    }

    function getMinutesSinceUpdate(lastUpdateStr) {
        const lastUpdateDate = parseLastUpdate(lastUpdateStr);
        const diffMs = Date.now() - lastUpdateDate.getTime();
        return Math.floor(diffMs / 60000);
    }

    function formatElapsedTime(minutes) {
        if (minutes < 60) {
            return `${minutes} min`;
        }

        const totalHours = Math.floor(minutes / 60);
        const remainingMinutes = minutes % 60;

        if (totalHours < 24) {
            return remainingMinutes > 0
                ? `${totalHours}h ${remainingMinutes}min`
                : `${totalHours}h`;
        }

        const days = Math.floor(totalHours / 24);
        const remainingHours = totalHours % 24;

        return remainingHours > 0
            ? `${days}d ${remainingHours}h`
            : `${days}d`;
    }
    const activeTelemetryAlarms = React.useMemo(() => {
        let count = 0;

        Object.values(monitors).forEach(section => {
            Object.values(section).forEach(item => {
                if (
                    (item.category === 2 || item.category === 3) &&
                    item.value !== 0
                ) {
                    count++;
                }
            });
        });

        return count;
    }, [monitors]);
    const emergencyAlarmCount = [
        "emerHomemMorto",
        "emerLacoFreio",
        "emerPortaAberta",
        "emerDescarrilhamento",
        "emerFalta3000v",
        "emerTensao2500v"
    ]
        .map(key => monitorValue(cabecalhoMonitor, key, 0))
        .filter(v => v !== 0)
        .length;
    return (
        <>
            {GlobalOverlays}

            <Box sx={styles.pageWrapper}>
                <Box component="main" sx={styles.mainContent}>
                    <Paper elevation={0} sx={{ ...styles.card, pl: 3, pr: 3, pt: 2, pb: 3 }}>

                        <UserEmailDisplay />

                        <div style={styles.detailHeader}>

                            <Typography variant="h5" sx={{ fontWeight: 700, color: '#111827', lineHeight: 1.2 }}>
                                Trem {trains.find(t => t.id === trainSelected)?.name ?? `Trem ${trainSelected}`}
                            </Typography>

                            {lastUpdate && (
                                <div
                                    style={{
                                        ...styles.lastUpdate,
                                        color:
                                            telemetryAlert === "critical"
                                                ? "#ff6b6b"
                                                : telemetryAlert === "warning"
                                                    ? "#f1c40f"
                                                    : "#6b7280"
                                    }}
                                >


                                    <span>Última atualização: {lastUpdate}</span>

                                    {telemetryAlert && (
                                        <span>
                                            {telemetryAlert === "critical"
                                                ? `🚨 Sem dados há ${formatElapsedTime(getMinutesSinceUpdate(lastUpdate))} — verifique a conexão do trem`
                                                : `⚠️ Atraso de ${formatElapsedTime(getMinutesSinceUpdate(lastUpdate))} na telemetria`}
                                        </span>
                                    )}

                                </div>
                            )}

                            <Button style={styles.backButton}
                                onClick={() => {
                                    setTrainSelected(null);
                                    setSelectedParam(null);
                                    setTrainHistory([]);
                                }}
                            >
                                ⬅ Voltar aos trens
                            </Button>

                        </div>
                        {/* cabecalho */}
                        <div style={styles.rowTop}>
                            <TrainStatusHeader
                                trainId={
                                    trains.find(
                                        t => t.id === trainSelected
                                    )?.name ?? "-"
                                }

                                ub="-"

                                line={currentTrain?.linhaNome ?? "-"}

                                cpb={
                                    monitorValue(
                                        cabecalhoMonitor,
                                        "atcAtivo1",
                                        0
                                    ) !== 0
                                }

                                ste={
                                    monitorValue(
                                        cabecalhoMonitor,
                                        "atcAtivo2",
                                        0
                                    ) !== 0
                                }

                                alarms={emergencyAlarmCount + activeTelemetryAlarms}

                                carro1={
                                    monitorValue(
                                        cabecalhoMonitor,
                                        "temperaturaCarro1",
                                        "--"
                                    )
                                }

                                carro8={
                                    monitorValue(
                                        cabecalhoMonitor,
                                        "temperaturaCarro8",
                                        "--"
                                    )
                                }
                            />

                            <EmergencyStatusGrid
                                items={[
                                    {
                                        label: "HOMEM\nMORTO",
                                        active:
                                            monitorValue(
                                                cabecalhoMonitor,
                                                "emerHomemMorto",
                                                0
                                            ) !== 0
                                    },

                                    {
                                        label: "LAÇO FREIO\nESTAC.",
                                        active:
                                            monitorValue(
                                                cabecalhoMonitor,
                                                "emerLacoFreio",
                                                0
                                            ) !== 0
                                    },

                                    {
                                        label: "PORTAS\nABERTAS",
                                        active:
                                            monitorValue(
                                                cabecalhoMonitor,
                                                "emerPortaAberta",
                                                0
                                            ) !== 0
                                    },

                                    {
                                        label: "DESCARRIL.",
                                        active:
                                            monitorValue(
                                                cabecalhoMonitor,
                                                "emerDescarrilhamento",
                                                0
                                            ) !== 0
                                    },

                                    {
                                        label: "BOTÃO DE\nSOCO",
                                        active:
                                            monitorValue(
                                                cabecalhoMonitor,
                                                "emerBotaoSocoCab",
                                                0
                                            ) !== 0
                                    },

                                    {
                                        label: "FALHA\nTCMS",
                                        active:
                                            monitorValue(
                                                cabecalhoMonitor,
                                                "emerFalhaTcms",
                                                0
                                            ) !== 0
                                    },

                                    {
                                        label: "AUSÊNCIA DE\n3000Vcc",
                                        active:
                                            monitorValue(
                                                cabecalhoMonitor,
                                                "emerFalta3000v",
                                                0
                                            ) !== 0
                                    },

                                    {
                                        label: "TENSÃO\n< 2500Vcc",
                                        active:
                                            monitorValue(
                                                cabecalhoMonitor,
                                                "emerTensao2500v",
                                                0
                                            ) !== 0
                                    },



                                    {
                                        label: "FREIO DE\nEMERG.",
                                        active:
                                            monitorValue(
                                                cabecalhoMonitor,
                                                "emerFreioEmerg",
                                                0
                                            ) !== 0
                                    },

                                    {
                                        label: "FALHA\nMVB",
                                        active:
                                            monitorValue(
                                                cabecalhoMonitor,
                                                "emerFalhaMvb",
                                                0
                                            ) !== 0
                                    },

                                    {
                                        label: "< 75%\nFREIO",
                                        active:
                                            monitorValue(
                                                cabecalhoMonitor,
                                                "emerMenos75Freio",
                                                0
                                            ) !== 0
                                    },

                                    {
                                        label: "VAZAMENTO\nDE AR",
                                        active:
                                            monitorValue(
                                                cabecalhoMonitor,
                                                "emerVazamentoAr",
                                                0
                                            ) !== 0
                                    },
                                ]}
                            />
                            <BypassStatusGrid
                                items={[
                                    {
                                        label: "HOMEM\nMORTO",
                                        active:
                                            monitorValue(
                                                cabecalhoMonitor,
                                                "bpHomemMorto",
                                                0
                                            ) !== 0
                                    },

                                    {
                                        label: "LIMITADOR\nPROPULSÃO",
                                        active:
                                            monitorValue(
                                                cabecalhoMonitor,
                                                "bpLimitPropulsao",
                                                0
                                            ) !== 0
                                    },

                                    {
                                        label: "PORTAS",
                                        active:
                                            monitorValue(
                                                cabecalhoMonitor,
                                                "bpPortas",
                                                0
                                            ) !== 0
                                    },

                                    {
                                        label: "FREIO\nEMERG.",
                                        active:
                                            monitorValue(
                                                cabecalhoMonitor,
                                                "bpFreioEmergencia",
                                                0
                                            ) !== 0
                                    },

                                    {
                                        label: "FREIO\nESTAC.",
                                        active:
                                            monitorValue(
                                                cabecalhoMonitor,
                                                "bpFreioEstacionario",
                                                0
                                            ) !== 0
                                    },

                                    {
                                        label: "DESCARRIL.",
                                        active:
                                            monitorValue(
                                                cabecalhoMonitor,
                                                "bpDescarrilhamento",
                                                0
                                            ) !== 0
                                    }
                                ]}
                            />
                        </div>
                        <Box sx={styles.layoutMain}>
                            <div style={styles.leftContent}>

                                <div style={styles.rowMiddle}>
                                    <TrainHVACPanel
                                        status={{
                                            cabineAtiva:
                                                monitorValue(
                                                    cabecalhoMonitor,
                                                    "cabineAtiva1",
                                                    0
                                                ) !== 0,

                                            atcAtivo:
                                                monitorValue(
                                                    cabecalhoMonitor,
                                                    "atcAtivo1",
                                                    0
                                                ) !== 0,

                                            atcIsolado:
                                                monitorValue(
                                                    cabecalhoMonitor,
                                                    "atcIsolado1",
                                                    0
                                                ) !== 0,

                                            atcFalha:
                                                monitorValue(
                                                    cabecalhoMonitor,
                                                    "atcFalha1",
                                                    0
                                                ) !== 0,

                                            velocidadeAtc:
                                                monitorValue(
                                                    cabecalhoMonitor,
                                                    "velocidadeAtc1",
                                                    0
                                                ),

                                            vr:
                                                monitorValue(
                                                    cabecalhoMonitor,
                                                    "vr1",
                                                    0
                                                ) !== 0
                                        }}

                                        cars={[
                                            {
                                                id: 1,

                                                temp: `${monitorValue(
                                                    cabecalhoMonitor,
                                                    "temperaturaCarro1",
                                                    "--"
                                                )}°`,

                                                passageiros: monitorValue(
                                                    cabecalhoMonitor,
                                                    "passageirosCarro1",
                                                    "--"
                                                )
                                            },

                                            {
                                                id: 2,

                                                temp: `${monitorValue(
                                                    cabecalhoMonitor,
                                                    "temperaturaCarro2",
                                                    "--"
                                                )}°`,

                                                passageiros: monitorValue(
                                                    cabecalhoMonitor,
                                                    "passageirosCarro2",
                                                    "--"
                                                )
                                            },

                                            {
                                                id: 3,

                                                temp: `${monitorValue(
                                                    cabecalhoMonitor,
                                                    "temperaturaCarro3",
                                                    "--"
                                                )}°`,

                                                passageiros: monitorValue(
                                                    cabecalhoMonitor,
                                                    "passageirosCarro3",
                                                    "--"
                                                )
                                            },

                                            {
                                                id: 4,

                                                temp: `${monitorValue(
                                                    cabecalhoMonitor,
                                                    "temperaturaCarro4",
                                                    "--"
                                                )}°`,

                                                passageiros: monitorValue(
                                                    cabecalhoMonitor,
                                                    "passageirosCarro4",
                                                    "--"
                                                )
                                            },

                                            {
                                                id: 5,

                                                temp: `${monitorValue(
                                                    cabecalhoMonitor,
                                                    "temperaturaCarro5",
                                                    "--"
                                                )}°`,

                                                passageiros: monitorValue(
                                                    cabecalhoMonitor,
                                                    "passageirosCarro5",
                                                    "--"
                                                )
                                            },

                                            {
                                                id: 6,

                                                temp: `${monitorValue(
                                                    cabecalhoMonitor,
                                                    "temperaturaCarro6",
                                                    "--"
                                                )}°`,

                                                passageiros: monitorValue(
                                                    cabecalhoMonitor,
                                                    "passageirosCarro6",
                                                    "--"
                                                )
                                            },

                                            {
                                                id: 7,

                                                temp: `${monitorValue(
                                                    cabecalhoMonitor,
                                                    "temperaturaCarro7",
                                                    "--"
                                                )}°`,

                                                passageiros: monitorValue(
                                                    cabecalhoMonitor,
                                                    "passageirosCarro7",
                                                    "--"
                                                )
                                            },

                                            {
                                                id: 8,

                                                temp: `${monitorValue(
                                                    cabecalhoMonitor,
                                                    "temperaturaCarro8",
                                                    "--"
                                                )}°`,

                                                passageiros: monitorValue(
                                                    cabecalhoMonitor,
                                                    "passageirosCarro8",
                                                    "--"
                                                )
                                            }
                                        ]}
                                    />
                                    {/* fim cabecalho */}
                                </div>

                                <DoorsSection
                                    portasMonitor={portasMonitor}
                                    tipoTrem={currentTrain?.tipoTrem}
                                />
                                {/* pantografos */}
                                <PantographSection
                                    pantografosMonitor={pantografosMonitor}
                                />
                                {/* fim pantografos */}
                                {/* tracao-e-alimentacao */}
                                <TractionSection
                                    tracaoMonitor={tracaoMonitor}

                                />
                                {/* fim tracao-e-alimentacao */}
                                {/* freio */}
                                <BrakeSection
                                    freioMonitor={freioMonitor}
                                />
                                {/* freio */}
                                {/* descarrilamento */}
                                <DerailmentSection
                                    descarrilamentoMonitor={
                                        descarrilamentoMonitor
                                    }
                                />
                                {/* fim descarrilamento */}
                                {/* incendio */}
                                <FireSection
                                    incendioMonitor={incendioMonitor}
                                />
                                {/* fim incendio */}
                                {/* emergencia */}
                                <EmergencySection
                                    emergenciaMonitor={emergenciaMonitor}
                                />
                                {/* fim emergencia */}
                                {/* conforto */}
                                <ComfortSection
                                    confortoMonitor={confortoMonitor}
                                />
                                {/* fim conforto */}


                            </div>
                            <Box sx={styles.rightPanel}>
                                {/* cabecalho */}
                                <TrainModePanel

                                    atcSpeed={
                                        monitorValue(
                                            cabecalhoMonitor,
                                            "velocidadeAtc1",
                                            0
                                        )
                                    }

                                    items={[
                                        {
                                            label: "Cabine ativa",
                                            value:
                                                monitorValue(
                                                    cabecalhoMonitor,
                                                    "cabineAtiva2",
                                                    0
                                                ) !== 0
                                                    ? "VMA1"
                                                    : "-",

                                            active:
                                                monitorValue(
                                                    cabecalhoMonitor,
                                                    "cabineAtiva2",
                                                    0
                                                ) !== 0
                                        },

                                        {
                                            label: "ATC ativo",

                                            value:
                                                monitorValue(
                                                    cabecalhoMonitor,
                                                    "atcAtivo2",
                                                    0
                                                ) !== 0
                                                    ? "VMA2"
                                                    : "-",

                                            active:
                                                monitorValue(
                                                    cabecalhoMonitor,
                                                    "atcAtivo2",
                                                    0
                                                ) !== 0
                                        },

                                        {
                                            label: "ATC isolado",

                                            value:
                                                monitorValue(
                                                    cabecalhoMonitor,
                                                    "atcIsolado2",
                                                    0
                                                ) !== 0
                                                    ? "VL"
                                                    : "-",

                                            active:
                                                monitorValue(
                                                    cabecalhoMonitor,
                                                    "atcIsolado2",
                                                    0
                                                ) !== 0
                                        },

                                        {
                                            label: "ATC em falha",
                                            value: "VR",

                                            active:
                                                monitorValue(
                                                    cabecalhoMonitor,
                                                    "atcFalha2",
                                                    0
                                                ) !== 0,

                                            valueActive:
                                                monitorValue(
                                                    cabecalhoMonitor,
                                                    "vr1",
                                                    0
                                                ) !== 0
                                        }
                                    ]}
                                />
                                {/* fim cabecalho */}

                                {/* barra lateral */}
                                {/* <AlertStackPanel
                                    items={[

                                        {
                                            label: "FREIO DE EMERGÊNCIA",

                                            active:
                                                monitorValue(
                                                    barraLateralMonitor,
                                                    "freioEmergencia",
                                                    0
                                                ) !== 0
                                        },

                                        {
                                            label: "FALHA DE MVB / LINHAS A/B",

                                            active:
                                                monitorValue(
                                                    barraLateralMonitor,
                                                    "falhaMvbLinhasAb",
                                                    0
                                                ) !== 0
                                        },

                                        {
                                            label: "VAZAMENTO DE AR",

                                            active:
                                                monitorValue(
                                                    barraLateralMonitor,
                                                    "vazamentoAr",
                                                    0
                                                ) !== 0
                                        },

                                        {
                                            label: "75% DE FREIO",

                                            active:
                                                monitorValue(
                                                    barraLateralMonitor,
                                                    "freio75",
                                                    0
                                                ) !== 0
                                        },

                                        {
                                            label: "< 75% DE FREIO",

                                            active:
                                                monitorValue(
                                                    barraLateralMonitor,
                                                    "freioAbaixo75",
                                                    0
                                                ) !== 0
                                        },

                                        {
                                            label: "FALHA DE TCMS",

                                            active:
                                                monitorValue(
                                                    barraLateralMonitor,
                                                    "falhaTcms",
                                                    0
                                                ) !== 0
                                        }

                                    ]}
                                /> */}

                                <div style={styles.metricsGrid}>

                                    {/* VELOCIDADE */}
                                    <div style={styles.metricCardCentered}>

                                        <div style={styles.metricTitle}>
                                            Velocidade
                                        </div>

                                        <GaugeContainer
                                            width={100}
                                            height={100}

                                            value={
                                                monitorValue(
                                                    barraLateralMonitor,
                                                    "velocidade",
                                                    0
                                                )
                                            }

                                            valueMin={0}
                                            valueMax={90}
                                            startAngle={-110}
                                            endAngle={110}
                                        >
                                            <GaugeReferenceArc />

                                            <GaugeValueArc
                                                sx={{ fill: "#5B21B6" }}
                                            />

                                            <Velocimetro />
                                        </GaugeContainer>

                                    </div>

                                    {/* TENSÃO */}
                                    <div style={styles.metricCardCentered}>

                                        <div style={styles.metricTitle}>
                                            Tensão na Linha
                                        </div>

                                        <Gauge
                                            width={100}
                                            height={100}

                                            value={
                                                monitorValue(
                                                    barraLateralMonitor,
                                                    "tensaoCatenaria",
                                                    0
                                                )
                                            }

                                            valueMin={0}
                                            valueMax={4000}

                                            startAngle={0}
                                            endAngle={360}

                                            text={({ value }) =>
                                                `${value.toFixed(0)} V`
                                            }

                                            sx={{
                                                "& .MuiGauge-valueArc": {
                                                    fill: "#5B21B6"
                                                },

                                                "& .MuiGauge-valueText": {
                                                    fill: "#66fcf1",
                                                    fontSize: "20px",
                                                    fontWeight: 600
                                                }
                                            }}
                                        />

                                    </div>

                                    {/* CORRENTE */}
                                    <div style={styles.metricCardCentered}>

                                        <div style={styles.metricTitle}>
                                            Consumo de Corrente
                                        </div>

                                        <Gauge
                                            width={100}
                                            height={100}

                                            value={
                                                monitorValue(
                                                    barraLateralMonitor,
                                                    "corrente",
                                                    0
                                                )
                                            }

                                            valueMin={0}
                                            valueMax={1000}

                                            startAngle={0}
                                            endAngle={360}

                                            text={({ value }) =>
                                                `${value.toFixed(0)} A`
                                            }

                                            sx={{
                                                "& .MuiGauge-valueArc": {
                                                    fill: "#5B21B6"
                                                },

                                                "& .MuiGauge-valueText": {
                                                    fill: "#66fcf1",
                                                    fontSize: "20px",
                                                    fontWeight: 600
                                                }
                                            }}
                                        />

                                    </div>

                                    {/* PRESSÃO */}
                                    <div style={styles.metricCardCentered}>

                                        <div style={styles.metricTitle}>
                                            Pressão no encanamento principal
                                        </div>

                                        <Gauge
                                            width={100}
                                            height={100}

                                            value={
                                                monitorValue(
                                                    barraLateralMonitor,
                                                    "pressaoPrincipal",
                                                    0
                                                )
                                            }

                                            valueMin={0}
                                            valueMax={100}

                                            startAngle={0}
                                            endAngle={360}

                                            text={({ value }) =>
                                                `${value.toFixed(1)} bar`
                                            }

                                            sx={{
                                                "& .MuiGauge-valueArc": {
                                                    fill: "#5B21B6"
                                                },

                                                "& .MuiGauge-valueText": {
                                                    fill: "#66fcf1",
                                                    fontSize: "20px",
                                                    fontWeight: 600
                                                }
                                            }}
                                        />

                                    </div>

                                    {/* DISTÂNCIA */}
                                    <div style={styles.metricCardCentered}>

                                        <div style={styles.metricTitle}>
                                            Odômetro
                                        </div>

                                        <div
                                            style={{
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                height: "100px",
                                                fontSize: "18px",
                                                fontWeight: 500,
                                            }}
                                        >
                                            {`${monitorValue(
                                                barraLateralMonitor,
                                                "distanciaPercorrida",
                                                0
                                            ).toFixed(0)} km`}
                                        </div>

                                    </div>

                                </div>
                                <TrainMiniMap gps={gps} />
                                {/* fim barra lateral */}
                            </Box>
                        </Box>

                        {/* CARDS DO TREM */}





                        {/* GRÁFICO PRINCIPAL */}

                        <div style={styles.mainChartContainer}>


                            <MetricWidget
                                key={`main-${selectedParam}`}
                                title={
                                    selectedParam
                                        ? (PARAMETER_MAP[selectedParam]?.name || `Parâmetro ${selectedParam}`)
                                        : "Selecione um Parâmetro"
                                }
                                color="#8b5cf6"
                                paramId={selectedParam}
                                history={trainHistory}
                                loading={loadingChart}
                            >

                                <div style={{ marginBottom: "16px" }}>

                                    <TimeRangeSelector
                                        timeRange={chartTimeRanges["main"] || (2 * 60 * 60 * 1000)}
                                        setTimeRange={(range) => {
                                            setTimeRange(range);
                                            updateChartTimeRange("main", range);
                                        }}
                                    />

                                    <ParamAutocomplete
                                        selectedParam={selectedParam}
                                        onSelect={(paramId) => {
                                            setSelectedParam(paramId);
                                            updateChartParam("main", paramId);
                                        }}
                                    />

                                </div>

                            </MetricWidget>

                        </div>


                        {/* GRÁFICOS ADICIONAIS */}
                        {additionalCharts.map((chart, index) => (

                            <div key={chart.id} style={styles.mainChartContainer}>

                                <MetricWidget
                                    key={chart.id}
                                    title={
                                        chart.paramId
                                            ? (PARAMETER_MAP[chart.paramId]?.name || `Parâmetro ${chart.paramId}`)
                                            : `Gráfico Adicional ${index + 1}`
                                    }
                                    color={['#3b82f6', '#10b981', '#f59e0b', '#ef4444'][index % 4]}
                                    paramId={chart.paramId}
                                    history={chart.history}
                                    loading={loadingGraficosAdicionais.has(chart.id)}
                                >

                                    <div style={{ marginBottom: "16px" }}>

                                        <div style={styles.headerHoras}>
                                            <TimeRangeSelector
                                                timeRange={chartTimeRanges[chart.id] || (2 * 60 * 60 * 1000)}
                                                setTimeRange={(range) => updateChartTimeRange(chart.id, range)}
                                            />

                                            <Button
                                                style={styles.btnRemover}
                                                onClick={() => removeChart(chart.id)}
                                            >
                                                Remover
                                            </Button>
                                        </div>

                                        <ParamAutocomplete
                                            selectedParam={chart.paramId}
                                            onSelect={(paramId) => {
                                                updateChartParam(chart.id, paramId);

                                                updateChartTimeRange(
                                                    chart.id,
                                                    chartTimeRanges[chart.id] || (2 * 60 * 60 * 1000)
                                                );
                                            }}
                                        />


                                    </div>

                                </MetricWidget>

                            </div>

                        ))}

                        {/* BOTÃO */}
                        <div style={{ marginTop: "20px", textAlign: "center" }}>

                            <Button
                                onClick={() => {
                                    const id = addChart();

                                    setTimeout(() => {
                                        updateChartTimeRange(id, 2 * 60 * 60 * 1000);
                                    }, 0);
                                }}
                                disabled={additionalCharts.length >= MAX_ADDITIONAL_CHARTS}
                                style={{
                                    padding: "10px 16px",
                                    background: additionalCharts.length >= MAX_ADDITIONAL_CHARTS ? "#555" : "#8b5cf6",
                                    color: "#fff",
                                    border: "none",
                                    borderRadius: "6px",
                                    cursor: "pointer"
                                }}
                            >
                                Adicionar Gráfico
                            </Button>

                            <div style={{ marginTop: "6px", fontSize: "12px", color: "#999" }}>
                                {additionalCharts.length} de {MAX_ADDITIONAL_CHARTS} gráficos adicionais
                            </div>

                        </div>
                        {/* CARROS */}

                        {/* <div style={styles.detailSection}>


                            <h3>Carros</h3>

                            <div style={styles.wagonsGrid}>


                                {cars.map((car) => (

                                    <CarCard
                                        key={car.id}
                                        car={car}
                                        onClick={() => {
                                            setSelectedParam(null);
                                            updateChartParam("main", null);
                                            setCarSelected(car.id);
                                            fetchCar(trainSelected, car.id);
                                        }}
                                    />

                                ))}

                            </div>

                        </div> */}


                        {/* TELEMETRIA RAW */}
                        <div style={styles.telemetryContainer}>

                            <h3 style={{ marginBottom: "10px" }}>
                                Telemetria Completa do Trem
                            </h3>

                            <div style={styles.telemetryScroll}>


                                <table style={styles.telemetryTable}>


                                    <thead>

                                        <tr style={styles.telemetryHeaderRow}>
                                            <th>ID</th>
                                            <th>Categoria</th>
                                            <th>Horário</th>
                                            <th>Carro</th>
                                            <th>Param ID</th>
                                            <th>Valor</th>
                                        </tr>

                                    </thead>

                                    <tbody>

                                        {uniqueDisplayRows
                                            .filter(row => PARAMETER_MAP[row.parameter_id] !== undefined)
                                            .map(row => {
                                                const formatTelemetryValue = (value) => {
                                                    const text = String(value);
                                                    return text.length > 4 ? `${text.slice(0, 4)}...` : text;
                                                };
                                                const rowKey = `${row.id}-${row.timestamp}-${row.carro}-${row.code}`;

                                                return (

                                                    <tr key={rowKey} style={{ textAlign: "center" }}>

                                                        <td>{row.id}</td>
                                                        <td>{row.raw_category}</td>

                                                        <td>

                                                            {new Date(Number(row.timestamp)).toLocaleString("pt-BR")}

                                                        </td>

                                                        <td>{row.carro}</td>

                                                        <td>
                                                            {row.parameter_id} - {row.description}
                                                        </td>

                                                        <td>{formatTelemetryValue(row.value)}</td>

                                                    </tr>

                                                );

                                            })}

                                    </tbody>

                                </table>

                            </div>

                        </div>

                    </Paper>
                </Box>
            </Box>


        </>
    );
}

export default TrainView;